import AppForm from '../app-components/Form/AppForm';

Vue.component('app-payment-trasaction-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                admin_user_id:  '' ,
                app_offices_id:  '' ,
                app_factories_id:  '' ,
                app_parent_factories_id:  '' ,
                app_farmer_drivers_id:  '' ,
                driver_name:  '' ,
                farmer_name:  '' ,
                factory_ticket_number:  '' ,
                weighing_date:  '' ,
                bruto:  '' ,
                tara:  '' ,
                potongan:  '' ,
                netto:  '' ,
                app_prices_factory_id:  '' ,
                app_fields_id:  '' ,
                price:  '' ,
                price_extra:  '' ,
                calculated_by:  '' ,
                farmer_total_payment:  '' ,
                driver_price:  '' ,
                driver_payment:  '' ,
                sopoi_price:  '' ,
                operational_price:  '' ,
                driver_total_payment:  '' ,
                total_payment:  '' ,
                farmer_print:  false ,
                driver_print:  false ,
                split_payment:  false ,
                app_factory_transaction_id:  '' ,
                
            }
        }
    }

});